import SmallPopupTemplate from "../small/SmallPopupTemplate";
import { COLORS } from "styles/colors";
import { useSelector } from "react-redux";
import { selectStomp } from "redux/stomp/stompSelector";
import { useEffect, useRef, useState } from "react";
import { Text } from "components/atoms/text/Text";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import {
  checkIsSuspended,
  checkPermission,
  CheckPermissionParamType,
  getSwitchAccountInfo,
} from "utils/AccountUtil";
import { UserGroupUserPermission } from "api/interfaces/userInterface.interface";
import { getCookie } from "cookies/cookie";
import { ACCESS_TOKEN } from "api/axiosInstance";
import { SUSPENSION_STATUS } from "redux/stomp/stompSubscriptionSlice";

type Props = {};

const excludePermissions = ["groupName", "enableDelete", "userGroupId"];

const ChangePermissionModal = (props: Props) => {
  const [isChangePermissionNotice, setIsChangePermissionNotice] =
    useState<boolean>(false);
  const { userPermissionUpdated, reconnectedDate } = useSelector(selectStomp);
  const isCheckPermission = useRef<boolean>(false);
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  useEffect(() => {
    if (!reconnectedDate) {
      if (
        !userPermissionUpdated ||
        isChangePermissionNotice ||
        !selectedAccount.accountId ||
        isCheckPermission.current ||
        !getCookie(ACCESS_TOKEN) ||
        selectedAccount.isHidden
      ) {
        return;
      }
    } else if (
      !selectedAccount.accountId ||
      !getCookie(ACCESS_TOKEN) ||
      isCheckPermission.current ||
      selectedAccount.isHidden
    ) {
      return;
    }

    isCheckPermission.current = true;
    getSwitchAccountInfo(
      selectedAccount.accountId,
      localStorage.getItem("r-mem") as string
    )
      .then((selectAccount) => {
        if (
          !!selectAccount &&
          checkIsSuspended(selectAccount) !== SUSPENSION_STATUS.DISABLED
        ) {
          return selectAccount;
        }
        return null;
      })
      .then((account) => {
        if (!!account) {
          const newPermission: UserGroupUserPermission = checkPermission(
            account as CheckPermissionParamType
          );
          for (const permission in newPermission) {
            if (
              !excludePermissions.includes(permission) &&
              selectedAccount.userPermission[
                permission as keyof UserGroupUserPermission
              ] !== undefined &&
              newPermission[permission as keyof UserGroupUserPermission] !==
                selectedAccount.userPermission[
                  permission as keyof UserGroupUserPermission
                ]
            ) {
              setIsChangePermissionNotice(true);
              break;
            }
          }
        }
      })
      .finally(() => {
        isCheckPermission.current = false;
      });
  }, [
    userPermissionUpdated,
    isChangePermissionNotice,
    selectedAccount.accountId,
    selectedAccount.userPermission,
    selectedAccount.isHidden,
    reconnectedDate,
  ]);

  if (isChangePermissionNotice) {
    return (
      <SmallPopupTemplate
        title={""}
        onClick={() => {
          window?.location?.reload();
        }}
        confirmLabel="OK"
        data-testid="templates-modal-auth-small-popup-template-click"
      >
        <Text fontSize={20} bold color={COLORS.RED}>
          Your permissions in organization have been changed
        </Text>
      </SmallPopupTemplate>
    );
  }

  return null;
};

export default ChangePermissionModal;
